module.exports = __webpack_public_path__ + "static/media/fab copy.8813bc1b.svg";